unit UOrdersMain;

interface

uses
  System.SysUtils,  System.Classes, Web,
  WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Types,
  WEBLib.DropDown, Vcl.Grids, WEBLib.Grids, Vcl.Controls, WEBLib.ExtCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, XData.Web.Client, WEBLib.DBCtrls, DB
  {$IFDEF DEBUG}
  ,WEBLib.WebTools
  {$ENDIF},
   WEBLib.Toast, Bcl.Utils, WEBLib.WebCtrls, JS, WEBLib.JSON;

type
  TfrmOrdersMain = class(TForm)
    toastInfo: TToast;
    WebMessageDlg1: TMessageDlg;
    divDateContainer: THTMLDiv;
    lblDate: TLabel;
    dtDelivery: TDateTimePicker;
    btnSearch: TButton;
    divOrderContainer: THTMLDiv;
    tblOrders: TTableControl;
    divContainer: THTMLDiv;
    procedure btnSearchClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure tblOrdersClickCell(Sender: TObject; ACol, ARow: Integer);
  private
  { Private declarations }
    procedure loadGridData(ADate: string; UserID: Integer);
    [async] procedure ShowLaundryDetails(lvalue: integer); async;
  public
  { Public declarations }
    procedure ShowHeaders;
  protected procedure LoadDFMValues; override; end;

var
  frmOrdersMain: TfrmOrdersMain;

implementation

{$R *.dfm}
uses
  DateUtils, ULogin, UDatamodule, UOrders, UErrorHandling, UHelper, UResources, UMainMenu, UJSHelper;

procedure TfrmOrdersMain.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;

procedure TfrmOrdersMain.WebFormCreate(Sender: TObject);
begin
  dtDelivery.Date := Now;
  ShowHeaders;
  loadGridData(FormatDateTime('yyyy-mm-dd', dtDelivery.Date), UDM.UserID);
end;

procedure TfrmOrdersMain.btnSearchClick(Sender: TObject);
begin
  loadGridData(FormatDateTime('yyyy-mm-dd', dtDelivery.Date), UDM.UserID);
end;

procedure TfrmOrdersMain.WebFormShow(Sender: TObject);
begin
{$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.OrdersMenuInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
    pas.UJSHelper.THTMLComponents.Translations();
  end;
{$ENDIF}

  if (UDM.OrderNr <> '') and (UDM.Form = sPageLogin) then
  begin
    ShowLaundryDetails(UDM.OrderNr.ToInteger);
  end;
end;

procedure TfrmOrdersMain.loadGridData(ADate: string; UserID: Integer);
var
  lToken: String;
  lURL: string;
begin
  lURL:= UDM.ServerURL + sAPIUserOrderDataOnwards;
  lToken:= UDM.AccessToken;
  {$IFNDEF WIN32}
  asm
    function start() {
    $.ajax({
        dataType: 'JSON',
        method: 'GET',
        beforeSend: function(request) {
          request.setRequestHeader('Authorization', 'Bearer '+ lToken);
          },
        data: {
            ADate: ADate,
            UserID: UserID
        },
        url: lURL,
        success: function (response) {

             pas.UOrdersMain.frmOrdersMain.tableDelphi = new DataTable('#tblOrdersTable', {
                data: response.value,
                order: [[1, 'asc']],
                initComplete: function( settings, json){

                  let selectedLangElements = document.getElementsByClassName("selected");
                  let selectedLang = selectedLangElements[0].dataset.lang;

                  pas.UJSHelper.THTMLComponents.Translations(selectedLang);
                },
                columnDefs: [
                        {
                            targets: 6,
                            render: function (data, type, row) {
                                return data.length > 10 ?
                                    data.substr(0, 10) + '…' :
                                    data;
                            }
                        },
                        {
                            targets: [0, 1, 2, 3, 4, 5],
                            className: 'dt-head-center dt-body-center'
                        },
//                        {
//                          targets: 0,
//                          visible: false,
//                          searchable: true
//                        },
                        {
                            targets: [6],
                            className: 'dt-head-center dt-body-left'
                        }
                    ],
                  columns: [
                      { title: "Nr", data: "Nr", width: '5%' },
                      { title: "Lieferdatum", data: "Datum", width: '15%' },
                      { title: "Uhrzeit", data: "Zeit", width: '12%' },
                      { title: "Schmutzwäschecontainer", data: "Dirty", width: '12%' },
                      { title: "Leercontainer zum Kunden liefern", data: "EmptyNeeded", width: '11%' },
                      { title: "Leercontainer vom Kunden abholen", data: "EmptyBack", width: '15%' },
                      { title: "Kommentar", data: "Comment", width: '30%' },
                  ],
                    scrollX: true,
                    scrollCollapse: true,
                    responsive: true,
                    destroy: true,
                });
                pas.UOrdersMain.frmOrdersMain.tableDelphi.on('click', 'tbody tr', function () {
                    let tabledata = pas.UOrdersMain.frmOrdersMain.tableDelphi.row(this).data();
                });
            },
            error: function (err) {
                console.log(err);
            }
        });
    }

    window.onload = start()
  end;
  {$ENDIF}
end;

procedure TfrmOrdersMain.ShowHeaders;
begin
  tblOrders.Cells[0,0] := 'Nr'; // Order no.
  tblOrders.Cells[1,0] := 'Lieferdatum'; // Date
  tblOrders.Cells[2,0] := 'Uhrzeit';  // Start of Driving
  tblOrders.Cells[3,0] := 'Schmutzwäschecontainer'; // Dirty
  tblOrders.Cells[4,0] := 'Leercontainer zum Kunden liefern'; // Empty Needed
  tblOrders.Cells[5,0] := 'Leercontainer vom Kunden abholen'; // Empty Back
  tblOrders.Cells[6,0] := 'Kommentar';  // Comment
end;

procedure TfrmOrdersMain.ShowLaundryDetails(lvalue: integer);
var
  lform: TfrmOrders;
  LResponse: TXDataClientResponse;
  LResponseData: TJSObject;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmOrders.CreateNew(divContainer.ElementID, nil);

  lform.SearchDate := dtDelivery.Date;
  lform.OrderID := lValue;

  THelper.DebugODS(dtDelivery.Text);
  THelper.DebugODS(DateToStr(dtDelivery.Date));
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('ILaundry.GetLaundryByNr',
        [lValue])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('create orders form and go to it.');

      if LResponse.ResponseText <> '' then
      begin
        LResponseData := TJSJSON.parseObject(LResponse.ResponseText);
        lform.edtDirty.Text := String(LResponseData.Properties['Dirty']);
        lform.edtEmptyNeeded.Text := String(LResponseData.Properties['EmptyNeeded']);
        lform.edtEmptyBack.Text := String(LResponseData.Properties['EmptyBack']);
        lform.mmComment.Lines.Add(String(LResponseData.Properties['Comment']));
        lform.edtModified.Text :=
          THelper.ISODateTimeFormat(String(LResponseData.Properties['ModifiedAt'])) +
          ' - ' + String(LResponseData.Properties['ModifiedByUser']);
        lform.LaundryID := Integer(LResponseData.Properties['LaundryID']);
        lform.lblDateText.Caption := String(LResponseData.Properties['Date']);
        lform.lblStartDrivingText.Caption := String(LResponseData.Properties['Time']);
      end
      else
        MessageDlg('An unexpected error occured', mtError, [mbAbort]);
    end
      else
        MessageDlg('Order not found.', mtInformation, [mbOk]);
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;

procedure TfrmOrdersMain.tblOrdersClickCell(Sender: TObject; ACol, ARow:
    Integer);
begin
   ShowLaundryDetails(StrToInt(tblOrders.cells[0, ARow]));
end;

procedure TfrmOrdersMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebMessageDlg1 := TMessageDlg.Create(Self);
  divContainer := THTMLDiv.Create('wcIDContainer');
  divOrderContainer := THTMLDiv.Create('wcIDMainContainer');
  divDateContainer := THTMLDiv.Create('wcIDDateContainer');
  lblDate := TLabel.Create('wcIDDateLbl');
  dtDelivery := TDateTimePicker.Create('wcIDDateInput');
  btnSearch := TButton.Create('wcIDSearchBtn');
  tblOrders := TTableControl.Create('wcIDOrdersTbl');
  toastInfo := TToast.Create(Self);

  WebMessageDlg1.BeforeLoadDFMValues;
  divContainer.BeforeLoadDFMValues;
  divOrderContainer.BeforeLoadDFMValues;
  divDateContainer.BeforeLoadDFMValues;
  lblDate.BeforeLoadDFMValues;
  dtDelivery.BeforeLoadDFMValues;
  btnSearch.BeforeLoadDFMValues;
  tblOrders.BeforeLoadDFMValues;
  toastInfo.BeforeLoadDFMValues;
  try
    Name := 'frmOrdersMain';
    Width := 1098;
    Height := 866;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 1082;
    WebMessageDlg1.Top := 154;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.HeightStyle := ssAuto;
    WebMessageDlg1.WidthStyle := ssAuto;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    divContainer.SetParentComponent(Self);
    divContainer.Name := 'divContainer';
    divContainer.Left := 0;
    divContainer.Top := 0;
    divContainer.Width := 1098;
    divContainer.Height := 866;
    divContainer.HeightStyle := ssAuto;
    divContainer.WidthStyle := ssAuto;
    divContainer.Align := alClient;
    divContainer.ChildOrder := 2;
    divContainer.ElementPosition := epIgnore;
    divContainer.ElementFont := efCSS;
    divContainer.Role := '';
    divOrderContainer.SetParentComponent(divContainer);
    divOrderContainer.Name := 'divOrderContainer';
    divOrderContainer.Left := 0;
    divOrderContainer.Top := 0;
    divOrderContainer.Width := 1098;
    divOrderContainer.Height := 866;
    divOrderContainer.ElementClassName := 'wcCLMainContainer Container';
    divOrderContainer.HeightStyle := ssAuto;
    divOrderContainer.WidthStyle := ssAuto;
    divOrderContainer.Align := alClient;
    divOrderContainer.ElementPosition := epIgnore;
    divOrderContainer.ElementFont := efCSS;
    divOrderContainer.Role := '';
    divDateContainer.SetParentComponent(divOrderContainer);
    divDateContainer.Name := 'divDateContainer';
    divDateContainer.Left := 0;
    divDateContainer.Top := 0;
    divDateContainer.Width := 1098;
    divDateContainer.Height := 121;
    divDateContainer.ElementClassName := 'row wcCLDateContainer';
    divDateContainer.HeightStyle := ssAuto;
    divDateContainer.WidthStyle := ssAuto;
    divDateContainer.Align := alTop;
    divDateContainer.ChildOrder := 1;
    divDateContainer.Role := '';
    lblDate.SetParentComponent(divDateContainer);
    lblDate.Name := 'lblDate';
    lblDate.Left := 125;
    lblDate.Top := 42;
    lblDate.Width := 170;
    lblDate.Height := 39;
    lblDate.Caption := 'Lieferdatum';
    lblDate.ElementClassName := 'wcCLDateLbl';
    lblDate.ElementPosition := epIgnore;
    lblDate.Font.Charset := DEFAULT_CHARSET;
    lblDate.Font.Color := clWindowText;
    lblDate.Font.Height := -32;
    lblDate.Font.Name := 'Tahoma';
    lblDate.Font.Style := [];
    lblDate.HeightStyle := ssAuto;
    lblDate.HeightPercent := 100.000000000000000000;
    lblDate.ParentFont := False;
    lblDate.Visible := False;
    lblDate.WidthStyle := ssAuto;
    lblDate.WidthPercent := 100.000000000000000000;
    dtDelivery.SetParentComponent(divDateContainer);
    dtDelivery.Name := 'dtDelivery';
    dtDelivery.Left := 347;
    dtDelivery.Top := 32;
    dtDelivery.Width := 217;
    dtDelivery.Height := 49;
    dtDelivery.ElementClassName := 'wcCLDateInput';
    dtDelivery.HeightStyle := ssAuto;
    dtDelivery.WidthStyle := ssAuto;
    dtDelivery.AutoDropDown := True;
    dtDelivery.BorderStyle := bsNone;
    dtDelivery.ChildOrder := 4;
    dtDelivery.Color := clCream;
    dtDelivery.Date := 45539.557474513890000000;
    dtDelivery.ElementFont := efCSS;
    dtDelivery.ElementPosition := epIgnore;
    dtDelivery.Font.Charset := DEFAULT_CHARSET;
    dtDelivery.Font.Color := clWindowText;
    dtDelivery.Font.Height := -27;
    dtDelivery.Font.Name := 'Tahoma';
    dtDelivery.Font.Style := [];
    dtDelivery.ParentFont := False;
    dtDelivery.Role := '';
    dtDelivery.TabOrder := 3;
    dtDelivery.Text := '';
    dtDelivery.Visible := False;
    btnSearch.SetParentComponent(divDateContainer);
    btnSearch.Name := 'btnSearch';
    btnSearch.Left := 624;
    btnSearch.Top := 58;
    btnSearch.Width := 96;
    btnSearch.Height := 25;
    btnSearch.Caption := 'Suche';
    btnSearch.ChildOrder := 2;
    btnSearch.ElementClassName := 'btn btn-primary wcCLSearchBtn';
    btnSearch.HeightPercent := 100.000000000000000000;
    btnSearch.Visible := False;
    btnSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearch, Self, 'OnClick', 'btnSearchClick');
    tblOrders.SetParentComponent(divOrderContainer);
    tblOrders.Name := 'tblOrders';
    tblOrders.Left := 125;
    tblOrders.Top := 250;
    tblOrders.Width := 705;
    tblOrders.Height := 369;
    tblOrders.ElementClassName := 'display wcCLTableOrders';
    tblOrders.HeightStyle := ssAuto;
    tblOrders.WidthStyle := ssAuto;
    tblOrders.BorderColor := clSilver;
    tblOrders.ChildOrder := 1;
    tblOrders.ElementFont := efCSS;
    tblOrders.ElementPosition := epIgnore;
    tblOrders.Font.Charset := DEFAULT_CHARSET;
    tblOrders.Font.Color := clWindowText;
    tblOrders.Font.Height := -16;
    tblOrders.Font.Name := 'Tahoma';
    tblOrders.Font.Style := [];
    tblOrders.ParentFont := False;
    SetEvent(tblOrders, Self, 'OnClickCell', 'tblOrdersClickCell');
    tblOrders.ColCount := 7;
    toastInfo.SetParentComponent(Self);
    toastInfo.Name := 'toastInfo';
    toastInfo.AutoHideDelay := 2000;
    toastInfo.Position := tpAbsolute;
    toastInfo.X := 750;
    toastInfo.Left := 65370;
    toastInfo.Top := 35;
  finally
    WebMessageDlg1.AfterLoadDFMValues;
    divContainer.AfterLoadDFMValues;
    divOrderContainer.AfterLoadDFMValues;
    divDateContainer.AfterLoadDFMValues;
    lblDate.AfterLoadDFMValues;
    dtDelivery.AfterLoadDFMValues;
    btnSearch.AfterLoadDFMValues;
    tblOrders.AfterLoadDFMValues;
    toastInfo.AfterLoadDFMValues;
  end;
end;

initialization
  RegisterClass(TfrmOrdersMain);

end.
